export default __webpack_public_path__ + "static/media/phygio101.5723fc1d.jpg";